/**
 * Acquisition `source` (`?source=IG` in a landing link). It's kept 7 days in a cookie so a visitor
 * who lands on a page and signs up later is still attributed; the signup sends it to the API
 * (`user.source`, Mixpanel `Sign up`) and to the Mixpanel profile.
 */

const COOKIE_NAME = 'source';
const MAX_AGE_SECONDS = 7 * 24 * 60 * 60;

/** Only the `source` query parameter (never the rest of the query string). */
export const getSourceParam = (search = window.location.search) =>
    new URLSearchParams(search || '').get(COOKIE_NAME) || '';

/** Saves `?source=` from the current URL, site-wide, for 7 days. No-op without the parameter. */
export const rememberSourceFromUrl = () => {
    const source = getSourceParam();
    if (!source) return;
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(source)}; max-age=${MAX_AGE_SECONDS}; path=/; SameSite=Lax`;
};

/** The remembered source ('' when there's none). */
export const getRememberedSource = () => {
    try {
        const found = document.cookie
            .split(';')
            .map((part) => part.trim())
            .find((part) => part.indexOf(`${COOKIE_NAME}=`) === 0);
        return found ? decodeURIComponent(found.substring(COOKIE_NAME.length + 1)) : '';
    } catch {
        return '';
    }
};
